export const ROUTE_PATHS = {
    engageToolList: '/account/:accountSlug/engage/tools/home/:section',
    duplicateModal: '/account/:accountSlug/engage/tools/home/:section/duplicate/:id',
    deleteModal: '/account/:accountSlug/engage/tools/home/:section/delete/:id',
}
